export enum AffiliateProgramsStoreStatus {
  Loading = 'loading',
  Creating = 'creating',
  Updating = 'updating',
  StatisticLoading = 'statistic_loading',
}
